import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralize } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

export const DocumentRetrievalBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { close } = useCommands();
    const {
        selectedDocumentRetrievalCount = 0,
        onDocumentRetrievalBulkRemoveFromTask,
        onDocumentRetrievalBulkStatementUnavailable,
        onDocumentRetrievalBulkAskAbout,
    } = options;

    const heading = `${selectedDocumentRetrievalCount} ${pluralize("row", selectedDocumentRetrievalCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {onDocumentRetrievalBulkRemoveFromTask && (
                <CommandItem
                    keywords={["remove", "detach", "unlink"]}
                    onSelect={() => {
                        close();
                        onDocumentRetrievalBulkRemoveFromTask();
                    }}
                >
                    Remove from task
                </CommandItem>
            )}
            {onDocumentRetrievalBulkStatementUnavailable && (
                <CommandItem
                    keywords={[
                        "statement",
                        "unavailable",
                        "missing",
                        "exclude",
                    ]}
                    onSelect={() => {
                        close();
                        onDocumentRetrievalBulkStatementUnavailable();
                    }}
                >
                    Statement unavailable
                </CommandItem>
            )}
            {onDocumentRetrievalBulkAskAbout && (
                <CommandItem
                    keywords={["add", "ask", "chat", "comment"]}
                    onSelect={() => {
                        close();
                        onDocumentRetrievalBulkAskAbout();
                    }}
                >
                    Add to chat
                </CommandItem>
            )}
        </Command.Group>
    );
};
